const STEPS = [
  "Submit information",
  "Receive integrated analysis",
  "Review priorities",
  "Discuss recommendations",
];

export const PostIntakeSteps = ({ testId, inverse = false, className = "" }) => (
  <div
    data-testid={testId}
    className={`flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-[0.58rem] uppercase tracking-[0.12em] leading-relaxed ${
      inverse ? "text-background/60" : "text-foreground/55"
    } ${className}`}
  >
    {STEPS.map((step, index) => (
      <span key={step} className="inline-flex items-center gap-2">
        <span data-testid={`${testId}-step-${index + 1}`}>{step}</span>
        {index < STEPS.length - 1 && <span aria-hidden className="text-accent">→</span>}
      </span>
    ))}
  </div>
);